import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { useLoginOnStartup } from '@micro-frontend-react/employee-experience/lib/useLoginOnStartup';
import { Header } from './Shared/Components/Header';
import { CoherenceThemeProvider } from './Shared/Components/CoherenceThemeProvider';
import { Nav } from './Shared/Components/Nav';
import { ShellWithStore } from './ShellWithStore';
import { Routes } from './Routes';
import { useHeaderConfig } from './useHeaderConfig';

export const navConfig = [
  {
    key: 'Main',
    links: [
      {
        key: 1,
        name: 'Applications',
        href: '/',
        icon: 'Home',
      },
      {
        key: 2,
        name: 'Components',
        href: '/components',
        icon: 'WebComponents',
      },
    ],
  },
];

function App(): React.ReactElement {
  useLoginOnStartup();
  const headerConfig = useHeaderConfig();

  return (
    <>
      <Header {...headerConfig} />
      <Nav groups={navConfig} />
      <main
        style={{
          height: 'fit-content',
          flexGrow: 1,
          backgroundColor: 'rgb(242, 242, 242)',
        }}
      >
        <Routes />
      </main>
    </>
  );
}

render(
  <ShellWithStore>
    <CoherenceThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </CoherenceThemeProvider>
  </ShellWithStore>,
  document.getElementById('app')
);
